module.exports = __webpack_public_path__ + "img/public.549c83c3.svg";